/** "2024-05-19" veya "2024-05-19T..." → "19.05.2024" */
export function formatDateTR(dateStr?: string | null): string {
    if (!dateStr) return '';
    const d = dateStr.slice(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(d)) return dateStr;
    const [y, m, day] = d.split('-');
    return `${day}.${m}.${y}`;
}

/** "19.05.2024" → "2024-05-19" (geçersizse '') */
export function parseDateTR(str?: string | null): string {
    if (!str) return '';
    const m = str.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    if (!m) return '';
    return `${m[3]}-${m[2]}-${m[1]}`;
}
